import React, { Component } from 'react';
import { Card, CardContent, CardHeader, List, ListItem, ListItemText, Divider, Box, Typography, Alert } from '@mui/material'
import TextFieldWithCounter from './TextFieldWithCounter';

export class CommentCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comments: [],
            discussionId: "",
            isDataLoaded: false
        };
        this.fetchData = this.fetchData.bind(this);
        this.callbackFunction = this.callbackFunction.bind(this);
    }

    async callbackFunction() {
        this.fetchData();
    }

    async componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        const res = await fetch("/api/commentsweb/" + this.props.discussionIdentifier, {
            headers: {
                "ClientIdentifier": this.props.clientIdentifier
            }
        });
        if (res.status === 200) {
            const results = await res.json();
            var obj = JSON.parse(results);

            if (Array.isArray(obj)) {
                this.setState({ comments: obj, isDataLoaded: true, discussionId: obj[0].discussionId });
            }
            else {
                this.setState({ isDataLoaded: true, discussionId: obj.documentId });
            } 
            this.props.callbackComment(obj);
        }
    }

    render() {
        const { comments, discussionId, isDataLoaded } = this.state;
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
        return (
            <Card>
                <CardHeader
                    title="Comments"
                    titleTypographyProps={{ variant: 'h1' }}
                    sx={{ textAlign: 'center' }}
                />
                <CardContent>
                    <Divider />
                    <List style={{ maxHeight: 450, overflow: 'auto' }}>
                        {                                   
                            comments.map(com =>
                                <ListItem
                                    key={com.commentId}
                                    divider>
                                    <ListItemText
                                        primary=
                                            {
                                            <Typography sx={{ display: 'inline' }}>        
                                                {com.user.userIdentifier} - {new Date(com.createdDate).toLocaleString('en-US', options)}
                                            </Typography>
                                            }
                                        secondary={com.comment} />
                                </ListItem>
                            )                                                
                        }                            
                    </List>
                    <Box
                        component="form"
                        sx={{
                            width: 1000,
                            maxWidth: '100%',
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        {this.props.isError &&
                            <Alert severity="error">A comment must be entered before performing that action.</Alert>
                        }
                        <TextFieldWithCounter
                            discussionId={discussionId}
                            clientIdentifier={this.props.clientIdentifier}
                            parentCallback={this.callbackFunction}
                            userIdentifier={this.props.userIdentifier}
                            isDataLoaded={isDataLoaded}
                            docLoaded={this.props.docLoaded}
                            discussRec={this.props.discussRec}
                            isError={this.props.isError}
                            errorCallback={this.props.errorCallback}
                        />
                    </Box>
                </CardContent>    
                
            </Card>
        );
    }
}